import { Component, EventEmitter, Output } from '@angular/core';
import { DeliveryChannelPreferences } from '../../models/MFAPreferencesResponse';
import { MFAPreferencesService } from 'src/app/services/mfaPreferences/mfaPreferences.service';
import { catchError, map, of, take } from 'rxjs';

export const CHANNEL_STATE = 0;
export const PIN_STATE = 1;

@Component({
  selector: 'wpro-verify-identity',
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.css'],
  standalone: false
})
export class VerifyIdentityComponent {
  @Output() verified = new EventEmitter<boolean>();
  /** NOTE for WLGN Shared Library
   * Add a spinner before GET MFA Preference.
   */
  channels$ = this.mfaPreferencesService.getUserMFAPreferences(true).pipe(
    take(1),
    map(response => response.output.deliveryChannelPreferences),
    catchError((err) => {
      this.isVerified(false);
      return of(null);
    })
  );
  step: number = CHANNEL_STATE;
  deliveryMethod: string;
  value: string;
  showDiffMethodLink: boolean;

  constructor(
    private mfaPreferencesService: MFAPreferencesService
  ) {}

  selectedChannel(output: { channel: DeliveryChannelPreferences; showDiffMethodLinkStatus: boolean }): void {
    if (output.channel && output.channel.deliveryMethod) {
      this.step++;
      this.deliveryMethod = output.channel.deliveryMethod;
      this.value = output.channel.value;
      this.showDiffMethodLink = output.showDiffMethodLinkStatus;
    } else {
      this.step--;
    }
  }

  isVerified(flag: boolean): void {
    this.verified.next(flag);
    this.verified.complete();
  }

  protected readonly CHANNEL_STATE = CHANNEL_STATE;
  protected readonly PIN_STATE = PIN_STATE;
}
